import { render, staticRenderFns } from "./PhoneWebHeader.vue?vue&type=template&id=61ccbe9d&scoped=true"
import script from "./PhoneWebHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneWebHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneWebHeader.vue?vue&type=style&index=0&id=61ccbe9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ccbe9d",
  null
  
)

export default component.exports